// =============== 📊 SCORING ENGINE INDEX ===============
// Central exports for scoring functionality

export {
  calculateEnhancedProfile,
  calculateAdaptiveMetrics,
  calculateCrossDimensionalInsights,
  generatePersonalizedPath,
  calculateConfidenceIntervals,
  enhanceAllCategoryScores,
  FEATURE_FLAGS
} from './enhancedProfile';

// =============== SCORING UTILITIES ===============
export const isAdvancedScoringEnabled = () => {
  return import.meta.env?.VITE_ADVANCED_SCORING === 'true' || true;
};

export const getScoringCapabilities = () => ({
  basic: true,
  enhanced: isAdvancedScoringEnabled(),
  crossDimensional: isAdvancedScoringEnabled(),
  confidenceIntervals: isAdvancedScoringEnabled(),
  developmentPaths: isAdvancedScoringEnabled(),
  version: isAdvancedScoringEnabled() ? '2.0' : '1.0'
});

// =============== SCORE SELECTOR ===============
export const getScoreCalculator = () => {
  if (isAdvancedScoringEnabled()) {
    return require('./enhancedProfile').calculateEnhancedProfile;
  }
  return require('../../modules/extendedAssessment/advancedScoring').calculateAdvancedScores;
};